import { create } from 'zustand';

export type BreadcrumbItem = {
	id: number;
	title: string;
	href: string;
};

type UseBreadcrumbStoreProps = {
	breadcrumbs: BreadcrumbItem[];
	setBreadcrumbs: (items: BreadcrumbItem[]) => void;
	resetBreadcrumbs: () => void;
};

export const useBreadcrumbStore = create<UseBreadcrumbStoreProps>((set) => ({
	breadcrumbs: [],
	setBreadcrumbs: (items) => set(() => ({ breadcrumbs: items })),
	resetBreadcrumbs: () => set(() => ({ breadcrumbs: [] })),
}));


